import { has } from 'lodash'

export function parseJwtToken(token) {
    try {
        let base64Url = token.split('.')[1]
        let base64 = base64Url.replace('-', '+').replace('_', '/')
        return JSON.parse(window.atob(base64))
    } catch (e) {
        return null
    }
}


export function detectLivefeedV2(livefeedSlides) {
    // The livefeed version 1 doesn't contain slideType key on livefeedSlide object
    let isLivefeedV2 = true // create new livefeed mode

    isLivefeedV2 = has(livefeedSlides[0], 'slideType')
    // new update for livefeed V2 which has steerpath mapConfig
    let slideshow1stIndex
    if (isLivefeedV2) {
        for (let i = 0; i < livefeedSlides.length; i++) {
            if (livefeedSlides[i].slideType === "slideshow") {
                slideshow1stIndex = i
            }
        }
        isLivefeedV2 = has(livefeedSlides[slideshow1stIndex].floorplanOptions, 'mapConfig')
    }

    return isLivefeedV2
}



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/utils.js